import type {
    ArgusClickConfig,
    ArgusClickLocation,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";

export type ArgusDomAttributes = {
    dataAnalyticsEvent: string | null;
    dataAnalyticsProps: string | null;
};

export type ArgusHtmlDataAttributes = {
    "data-analytics-event"?: string;
    "data-analytics-props"?: string;
};

export type ArgusEventConfig = {
    event: string;
    props?: Record<string, unknown>;
};

export function argusClickConfigWithLocation(
    argus: ArgusClickConfig | null | undefined,
    location: ArgusClickLocation,
): ArgusClickConfig | null {
    if (argus === null || argus === undefined) {
        return null;
    }
    if (argus.props === undefined) {
        return {
            event: argus.event,
        };
    }
    return {
        event: argus.event,
        props: {
            location: location,
            level: argus.props.level,
            parent: argus.props.parent,
            type: argus.props.type,
        },
    };
}

function emptyArgusDomAttributes(): ArgusDomAttributes {
    return {
        dataAnalyticsEvent: null,
        dataAnalyticsProps: null,
    };
}

export function argusDomAttributes(argus: ArgusEventConfig | ArgusClickConfig | null | undefined): ArgusDomAttributes {
    if (argus === null || argus === undefined) {
        return emptyArgusDomAttributes();
    }
    const eventName = argus.event.trim();
    if (eventName === "") {
        return emptyArgusDomAttributes();
    }
    if (argus.props === undefined) {
        return {
            dataAnalyticsEvent: eventName,
            dataAnalyticsProps: null,
        };
    }
    return {
        dataAnalyticsEvent: eventName,
        dataAnalyticsProps: JSON.stringify(argus.props),
    };
}

export function pickArgusDomAttributes(value: Partial<ArgusDomAttributes>): ArgusDomAttributes {
    const eventName = value.dataAnalyticsEvent;
    if (eventName === undefined || eventName === null) {
        return emptyArgusDomAttributes();
    }
    const trimmedEventName = eventName.trim();
    if (trimmedEventName === "") {
        return emptyArgusDomAttributes();
    }
    const propsJson = value.dataAnalyticsProps;
    if (propsJson === undefined || propsJson === null) {
        return {
            dataAnalyticsEvent: trimmedEventName,
            dataAnalyticsProps: null,
        };
    }
    return {
        dataAnalyticsEvent: trimmedEventName,
        dataAnalyticsProps: propsJson,
    };
}

export function toArgusHtmlDataAttributes(value: ArgusDomAttributes): ArgusHtmlDataAttributes {
    const attributes: ArgusHtmlDataAttributes = {};
    if (value.dataAnalyticsEvent !== null) {
        attributes["data-analytics-event"] = value.dataAnalyticsEvent;
    }
    if (value.dataAnalyticsProps !== null) {
        attributes["data-analytics-props"] = value.dataAnalyticsProps;
    }
    return attributes;
}
